import { gql } from "@apollo/client";
import {TypeDefinitionAttributeFields} from "../fragments/typeDefinitionAttribute";

export const ToastMessageListTDAs = gql`
    query ToastMessageListTDAs ($typeDefinitionIndex: ToastMessageTypeDefinitionIndex!) {
        toastMessageList {
            typeDefinitionAttributeList (typeDefinitionIndex: $typeDefinitionIndex) {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
